import React, {
  useState,
  useEffect,
  Fragment,
  useRef,
  useCallback,
} from "react";
import Header from "../../layout/Header";
import "./Tickets.css";
import {
  fetchCategoriesAndSubCategories,
  fetchCategoriesAndSubCategoriesList,
  fetchCityData,
  fetchCompanies,
  fetchCompaniesData,
  fetchDashboard,
  fetchDashboardTickets,
  fetchDataBasedOnTktId,
  fetchDepartment,
  fetchDepartmentFilter,
  fetchTicketStatus,
  fetchTicketStatusOptionsData,
  fetchTicketType,
  getAssigneeBaseInfo,
  getLocation,
  getLocationInsights,
  quickFilter,
  submitTicketStatus,
  updateTicketStatus,
} from "../../utils/API/TicketAPI";
import { useToken } from "../../utils/TokenContext";
import Sidebar from "../../layout/Sidebar";
import {
  Dropdown,
  Modal,
  Button,
  ToggleButton,
  Tooltip,
  OverlayTrigger,
} from "react-bootstrap";
import Collapse from "react-bootstrap/Collapse";
import Form from "react-bootstrap/Form";
import { toast } from "react-toastify";
import CriticalIcon from "../../assests/img/critical-icon.svg";
import NoDataBg from "../../assests/img/No-data-bg.svg";

import E1Icon from "../../assests/img/E1-icon.svg";
import { MultiSelect } from "react-multi-select-component";
import { handleLogOut } from "../../utils/ClearCache";
import DateRangePicker from "react-bootstrap-daterangepicker";
import "bootstrap-daterangepicker/daterangepicker.css";
import moment from "moment";
import Chart from "react-apexcharts";
import HappinessRatingImage from "../../assests/img/Happiness-rating-stars.png";
import Ticket from "./Ticket";
import ChangeStatusModal from "./Modals/ChangeStatusModal";
import { useNavigate } from "react-router-dom";

import HappinessRating1 from "../../assests/img/Ratings/Rating-1.svg";
import HappinessRating15 from "../../assests/img/Ratings/Rating-1_5.svg";
import HappinessRating2 from "../../assests/img/Ratings/Rating-2.svg";
import HappinessRating25 from "../../assests/img/Ratings/Rating-2_5.svg";
import HappinessRating3 from "../../assests/img/Ratings/Rating-3.svg";
import HappinessRating35 from "../../assests/img/Ratings/Rating-3_5.svg";
import HappinessRating4 from "../../assests/img/Ratings/Rating-4.svg";
import HappinessRating45 from "../../assests/img/Ratings/Rating-4_5.svg";
import HappinessRating5 from "../../assests/img/Ratings/Rating-5.svg";
import RatingNotApplicableImg from "../../assests/img/Ratings/Rating-Not-Applicable.svg";
import FilterLocationIcon from "../Common/img/FIlter-Location-Icon.svg";
import FilterTicketClassificationIcon from "../Common/img/Filter-TicketClassification-Icon.svg";
import FilterMoreFIltersIcon from "../Common/img/Filter-MoreFilters-Icon.svg";
import { v4 as uuidv4 } from "uuid";
import starIcon from "../../assests/img/Ratings/star-icon.svg";
import axiosInstance from "../../utils/axiosInstance";

const Dashboard = () => {
  const [activeTab, setActiveTab] = useState("all");
  const [activeTabTicket, setActiveTabTicket] = useState("open");
  const [seriesData, setSeriesData] = useState([]);
  const [filterOpen, setFilterOpen] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [locationData, setLocationData] = useState([]);
  const [selectedLocation, setSelectedLocation] = useState([]);
  const [companyOptions, setCompanyOptions] = useState([]);
  const [selectedCompanies, setSelectedCompanies] = useState([]);
  const [selectedTicketTypes, setSelectedTicketTypes] = useState([]);
  // const [isValidToken, setIsValidToken] = useState(true);
  const [selectedDepartments, setSelectedDepartments] = useState([]);
  const [selectedCategories, setSelectedCategories] = useState([]);
  const [categoryOptions, setCategoryOptions] = useState([]);
  const [allSubCategoryOptions, setAllSubCategoryOptions] = useState([]);
  const [filteredSubCategoryOptions, setFilteredSubCategoryOptions] = useState(
    []
  );
  const [selectedSubCategories, setSelectedSubCategories] = useState([]);
  const [selectedDateRange, setSelectedDateRange] = useState({
    startDate: null,
    endDate: null,
  });
  const [selectedRatings, setSelectedRatings] = useState([]);
  const [selectedTicketStatus, setSelectedTicketStatus] = useState([]);
  // Response set for fetchDashboardData
  const [kpiData, setKpiData] = useState();
  const [ratingData, setRatingData] = useState();
  const [slaData, setSlaData] = useState();
  const [statusCount, setStatusCount] = useState();
  const [statusData, setStatusData] = useState([]);
  const [categoryListData, setCategoryListData] = useState([]);
  const [companyListData, setCompanyListData] = useState([]);
  const [departmentListData, setDepartmentListData] = useState([]);
  const [cityOptions, setCityOptions] = useState([]);
  const [selectedCity, setSelectedCity] = useState([]);
  const [locationListData, setLocationListData] = useState([]);
  const [subcategoryListData, setSubcategoryListData] = useState([]);

  const [selectedTicketId, setSelectedTicketId] = useState(null);
  const [hasMoreTickets, setHasMoreTickets] = useState(true);
  const [tickets, setTickets] = useState([]);

  const [modalTicketId, setModalTicketId] = useState("");

  const [modalButtonValue, setModalButtonValue] = useState("");
  const [showChangeStatusModal, setShowChangeStatusModal] = useState(false);
  const [showLoader, setShowLoader] = useState(false);

  const [ticketDetails, setTicketDetails] = useState(null);

  const [allData, setAllData] = useState([]);

  const [escData, setEscData] = useState([]);

  const [loading, setLoading] = useState(false);

  const [globalTicket, setGlobalTicket] = useState(null);

  const [departmentOptions, setDepartmentOptions] = useState([]);

  const [ticketStatusOptions, setTicketStatusOptions] = useState([]);

  const [ticketTypeOptions, setTicketTypeOptions] = useState([]);

  const [applyFilterValue, setApplyFilterValue] = useState(null);

  const [selectedRegions, setSelectedRegions] = useState([]);
  const [selectedEscalations, setSelectedEscalations] = useState([]);

  const [raiseticketStatud, setRaiseticketStatud] = useState(false);

  const [dataRaiseTT, setDataRaiseTT] = useState([]);

  const [quick, setQuick] = useState([]);
  const [activeQuickFilter, setActiveQuickFilter] = useState(null); //for quick filter
  const [userDetails, setUserDetails] = useState("");
  const [groupTypeOpExist, setGroupTypeOpExist] = useState(false);
  const [selectedRelevance, setSelectedRelevance] = useState([
    { label: "Relevant", value: "relevant" },
  ]);
  const [groupTypeOpExistAm, setGroupTypeOpExistAm] = useState(false);
  const [allDepartmentOptions, setAllDepartmentOptions] = useState([]);
  // const { token } = useToken();

  const navigate = useNavigate();

  const observer = useRef();

  const regionOptions = [
    { label: "North", value: "north" },
    { label: "South", value: "south" },
    { label: "East", value: "east" },
    { label: "West", value: "west" },
  ];

  const escalationStatusOptions = [
    { label: "E1", value: "E1" },
    { label: "E2", value: "E2" },
    { label: "E3", value: "E3" },
    { label: "Critical", value: "Critical" },
    { label: "Non Violated", value: "Non Violated" },
    { label: "Reopen", value: "Reopen" },
    { label: "Returned", value: "Returned" },
    { label: "Over Due", value: "Over Due" },
    { label: "Returned", value: "Returned" },
  ];

  const relevanceOptions = [
    { label: "Relevant", value: "relevant" },
    { label: "Irrelevant", value: "irrelevant" },
  ];

  // useEffect(() => {
  //   if (!isValidToken) {
  //     handleLogOut();
  //     window.location.href = "/";
  //   }
  // }, [isValidToken]);

  const showToast = (message) => {
    toast.error(message);
  };

  const showToastSuccess = (message) => {
    toast.success(message);
  };

  const handleTabClick = (tab) => {
    setActiveTab(tab);
    setHasMoreTickets(true);
    setCurrentPage(1);
    setTickets([]);
  };

  const handleTabClickWithFetch = (tab) => {
    if (tab === activeTab) return;
    handleTabClick(tab);
    setSlaData(slaData?.violatedTickets);
    localStorage.setItem("activeTab", tab);
  };

  //  Start Location Dropdown Code
  const fetchAllLocation = async (cities) => {
    try {
      const cityQuery = cities && cities.length > 0 ? cities.join(",") : "";
      console.log("Fetching locations with cityQuery:", cityQuery);
      const response = await getLocationInsights(cityQuery);
      console.log("Location API response:", response);
      if (response.statusValue === 200) {
        const sortedLocations = response.data
          .map((location) => ({
            value: location._id,
            label: location.locationName,
          }))
          .sort((a, b) => a.label.localeCompare(b.label));
        setLocationData(sortedLocations);
         // Auto-select if only one location is available
         if (sortedLocations.length === 1) {
          setSelectedLocation(sortedLocations);
        }
      } else {
        setLocationData([]);
      }
    } catch (error) {
      console.error("Error fetching locations:", error);
      setLocationData([]);
      showToast(
        `Error fetching location: ${
          error?.response?.data?.error?.message || error.message
        }`
      );
    }
  };

  //  Start Location Dropdown Code
  const fetchAllCity = async (regions) => {
    try {
      const regionQuery =
        regions && regions.length > 0 ? regions.join(",") : "";
      const response = await fetchCityData(regionQuery);
      if (response.data.statusValue === 200) {
        const options = response.data.data
          .map((city) => ({
            label: city,
            value: city,
          }))
          .sort((a, b) => a.label.localeCompare(b.label));
        setCityOptions(options);
        // Auto-select if only one city is available
        if (options.length === 1) {
          setSelectedCity(options);
        }
      } else {
        setCityOptions([]);
      }
    } catch (error) {
      showToast(
        `Error fetching location : ${error?.response?.data?.error?.message}`
      );
    }
  };

  // useEffect(()=> {
  //   fetchAllCity();
  // })

  // useEffect(() => {
  //   const allOptions = locationData.map((location) => ({
  //     value: location._id,
  //     label: location.locationName,
  //   }));
  //   setSelectedLocation(allOptions);
  // }, [locationData]);

  useEffect(() => {
    setCurrentPage(1);
  }, [selectedLocation]);

  useEffect(() => {
    //fetchAllCity();
    fetchQuickFilter();
  }, []);

  const handleChange = (selected) => {
    setSelectedLocation(selected);
    fetchCompaniesDataInsights(selected);
    // setActiveTab("Location");
    setSelectedCompanies([])
  };

  const ArrowRenderer = ({ expanded }) => (
    <>
      {expanded ? (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="10"
          height="5"
          viewBox="0 0 12 6"
        >
          <path id="UpArrow_dropdown" d="M6,0,0,6H12Z" fill="#ccc" />
        </svg>
      ) : (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="10"
          height="5"
          viewBox="0 0 12 6"
        >
          <path id="UpArrow_dropdown" d="M6,6,0,0H12Z" fill="#ccc" />
        </svg>
      )}
    </>
  );

  const ValueRenderer = (selected, options) => {
    if (selected.length === options.length) {
      return "All locations";
    } else if (selected.length === 1) {
      return selected[0].label;
    } else {
      return selected.length > 0
        ? `${selected.length} locations selected`
        : "Select Location";
    }
  };

  //  End Location Dropdown Code

  const fetchCompaniesDataInsights = async (locations) => {
    const locationArr = locations !== undefined ? locations : selectedLocation;
    try {
      const locationQuery =
        locationArr.length > 0
          ? locationArr.map((location) => location.value).join(",")
          : "";
      const response = await fetchCompaniesData(locationQuery);
      if (response.data.statusValue === 200) {
        const companies = response.data.data
          .sort((a, b) => a.companyName.localeCompare(b.companyName))
          .map((company) => ({
            label: company.companyName,
            value: company.companyName,
          }));
        setCompanyOptions(companies);
        if (companies.length === 1) {
          setSelectedCompanies(companies);
        }
      } else {
        setCompanyOptions([]);
      }
    } catch (error) {
      console.error("Error fetching company names", error);
    }
  };

  const fetchDepartmentOptions = async (groupType) => {
    try {
      const response = await fetchDepartmentFilter(groupType);
      if (response.data.statusValue === 200) {
        const departments = response.data.data
          .sort((a, b) => a.label.localeCompare(b.label))
          .map((dept) => ({
            label: dept.label,
            value: dept.value,
          }));

        setDepartmentOptions(departments);
        if (departments.length === 1) {
          setSelectedDepartments(departments);
        } 
      } else {
        setDepartmentOptions([]);
      }
    } catch (error) {
      console.error("Error fetching department names", error);
    }
  };

  const fetchTicketStatusOptions = async (departments) => {
    try {
      const deptQuery =
        departments && departments.length > 0 ? departments.join(",") : "";
      const response = await fetchTicketStatusOptionsData(deptQuery);
      if (response.data.statusValue === 200) {
        const status = response.data.data
          .sort((a, b) => a.label.localeCompare(b.label))
          .map((status) => ({
            label: status.label,
            value: status.value,
          }));

        setTicketStatusOptions(status);
        if (status.length === 1) {
          setSelectedTicketStatus(status);
        } 
      } else {
        setTicketStatusOptions([]);
      }
    } catch (error) {
      console.error("Error fetching status", error);
    }
  };

  const fetchTicketTypeOptions = async () => {
    try {
      const response = await fetchTicketType();
      if (response.data.statusValue === 200) {
        const type = response.data.data
          .sort((a, b) => a.label.localeCompare(b.label))
          .map((type) => ({
            label: type.label,
            value: type.value,
          }));

        setTicketTypeOptions(type);
        if (type.length === 1) {
          setSelectedTicketTypes(type);
        } 
      } else {
        setTicketTypeOptions([]);
      }
    } catch (error) {
      console.error("Error fetching ticket type", error);
    }
  };

  const ValueRendererCompany = (selectedCompany, optionsComapny) => {
    if (selectedCompany.length === optionsComapny.length) {
      return "All companies";
    } else if (selectedCompany.length === 1) {
      return selectedCompany[0].label;
    } else {
      return selectedCompany.length > 0
        ? `${selectedCompany.length} companies selected`
        : "Select Company";
    }
  };

  const ValueRendererRelevance = (selectedRelevance, optionsRelevance) => {
    if (selectedRelevance.length === optionsRelevance.length) {
      return "All relevance";
    } else if (selectedRelevance.length === 1) {
      return selectedRelevance[0].label;
    } else {
      return selectedRelevance.length > 0
        ? `${selectedRelevance.length} relevance selected`
        : "Select Relevance";
    }
  };

  // const ticketTypeOptions = [
  //   { label: "Internal", value: "internal" },
  //   { label: "Support", value: "support" },
  //   { label: "Service", value: "service" },
  //   { label: "SPOC", value: "spoc" },
  //   { label: "MSD", value: "msd" },
  // ];

  const ValueRendererTicket = (selectedTkt, optionsTkt) => {
    if (selectedTkt.length === optionsTkt.length) {
      return "All ticket types";
    } else if (selectedTkt.length === 1) {
      return selectedTkt[0].label;
    } else {
      return selectedTkt.length > 0
        ? `${selectedTkt.length} ticket types selected`
        : "Select Ticket Type";
    }
  };

  // const departmentOptions = [
  //   { label: "Operations", value: "op" },
  //   { label: "IT", value: "it" },
  //   { label: "Tech", value: "tc" },
  //   { label: "Account Management", value: "am" },
  //   { label: "MSD", value: "md" },
  //   { label: "InfoSec", value: "is" },
  // ];

  const ValueRendererDepartment = (selectedDept, optionsDept) => {
    if (selectedDept.length === optionsDept.length) {
      return "All departments";
    } else if (selectedDept.length === 1) {
      return selectedDept[0].label;
    } else {
      return selectedDept.length > 0
        ? `${selectedDept.length} departments selected`
        : "Select Department";
    }
  };

  const ValueRendererCity = (selectedCity, optionsDept) => {
    if (selectedCity.length === optionsDept.length) {
      return "All cities";
    } else if (selectedCity.length === 1) {
      return selectedCity[0].label;
    } else {
      return selectedCity.length > 0
        ? `${selectedCity.length} cities selected`
        : "Select City";
    }
  };

  const ValueRendererRegion = (selectedRegion, optionsRegion) => {
    if (selectedRegion.length === optionsRegion.length) {
      return "All regions";
    } else if (selectedRegion.length === 1) {
      return selectedRegion[0].label;
    } else {
      return selectedRegion.length > 0
        ? `${selectedRegion.length} regions selected`
        : "Select Region";
    }
  };

  const ValueRendererEscalation = (selectedEscalations, optionsEscalation) => {
    if (selectedEscalations.length === optionsEscalation.length) {
      return "All escalations status";
    } else if (selectedEscalations.length === 1) {
      return selectedEscalations[0].label;
    } else {
      return selectedEscalations.length > 0
        ? `${selectedEscalations.length} escalations status selected`
        : "Select Escalation Status";
    }
  };

  // Function to create an array of star icons
  const createStarLabel = (count) => (
    <div style={{ display: "flex" }}>
      {[...Array(count)].map((_, index) => (
        <img
          key={index}
          src={starIcon}
          alt="star"
          style={{ width: 20, height: 20, marginRight: 2 }}
        />
      ))}
    </div>
  );

  const ratingsOptions = [
    { label: "Not rated Yet", value: "notRated" },
    { label: createStarLabel(1), value: "1" },
    { label: createStarLabel(2), value: "2" },
    { label: createStarLabel(3), value: "3" },
    { label: createStarLabel(4), value: "4" },
    { label: createStarLabel(5), value: "5" },
  ];

  const ValueRendererRatings = (selectedRatings, optionsRatings) => {
    if (selectedRatings.length === optionsRatings.length) {
      return "All ratings";
    } else if (selectedRatings.length === 1) {
      return selectedRatings[0].label;
    } else {
      return selectedRatings.length > 0
        ? `${selectedRatings.length} ratings selected`
        : "Select Ticket Ratings";
    }
  };

  // const ticketStatusOptions = [
  //   { label: "To Do", value: "To Do" },
  //   { label: "In Progress", value: "In Progress" },
  //   { label: "Under Review", value: "Under Review" },
  //   { label: "Reopened", value: "Reopen" },
  //   { label: "Done", value: "Done" },
  // ];

  const ValueRendererTicketStatus = (
    selectedTicketStatus,
    optionsTicketStatus
  ) => {
    if (selectedTicketStatus.length === optionsTicketStatus.length) {
      return "All ticket status";
    } else if (selectedTicketStatus.length === 1) {
      return selectedTicketStatus[0].label;
    } else {
      return selectedTicketStatus.length > 0
        ? `${selectedTicketStatus.length} ticket status selected`
        : "Select Ticket Status";
    }
  };

  const fetchCategoriesAndSubCategoriesData = async (departments) => {
    try {
      const deptQuery =
        departments && departments.length > 0 ? departments.join(",") : "";

      const response = await fetchCategoriesAndSubCategoriesList(deptQuery);
      if (response.data.statusValue === 200) {
        const categories = response.data.data
          .sort((a, b) => a.category.localeCompare(b.category))
          .map((item) => ({
            label: item.category,
            value: item.category,
          }));

        setCategoryOptions(categories);
        if (categories?.length === 1) {
          setSelectedCategories([categories[0]]); // Wrap in array
        }

        const subCategories = response.data.data.map((item) => ({
          category: item.category,
          subCategories: item.subCategories
            .map((sub) => ({
              label: sub,
              value: sub,
            }))
            .sort((a, b) => a.label.localeCompare(b.label)), // Sort subcategories alphabetically
        }));

        setAllSubCategoryOptions(subCategories);
        
        // Auto-select subcategory if there's only one option
        if (selectedCategories.length > 0) {
          const subCategoryOptions = subCategories.find(
            cat => cat.category === selectedCategories[0].value
          )?.subCategories;
          if (subCategoryOptions && subCategoryOptions.length === 1) {
            setSelectedSubCategories([subCategoryOptions[0]]); // Pass the entire object instead of just value
          }
        }
      } else {
        setCategoryOptions([]);
        setAllSubCategoryOptions([]);
        setSelectedCategories([]);
        setSelectedSubCategories([]);
      }
    } catch (error) {
      console.error("Error fetching categories and subcategories", error);
    }
  };

  useEffect(() => {
    if (selectedCategories.length > 0) {
      setSelectedSubCategories([]); // Reset subcategory selection when category changes
      
      // Auto-select subcategory if there's only one option
      const subCategoryOptions = allSubCategoryOptions.find(
        cat => cat.category === selectedCategories[0].value
      )?.subCategories;
      
      if (subCategoryOptions && subCategoryOptions.length === 1) {
        setSelectedSubCategories([subCategoryOptions[0]]); // Pass the entire object
      }
    } else {
      setSelectedSubCategories([]);
    }
  }, [selectedCategories, allSubCategoryOptions]);

  useEffect(() => {
    if (selectedCategories.length === 0) {
      setFilteredSubCategoryOptions([]);
    } else {
      const filteredSubCategories = allSubCategoryOptions
        .filter((option) =>
          selectedCategories.some((cat) => cat.value === option.category)
        )
        .flatMap((option) => option.subCategories);
      const uniqueSubCategoryOptions = [
        ...filteredSubCategories
          .reduce((map, obj) => {
            const key = `${obj.label}-${obj.value}`;
            if (!map.has(key)) {
              map.set(key, obj);
            }
            return map;
          }, new Map())
          .values(),
      ];

      setFilteredSubCategoryOptions(uniqueSubCategoryOptions);
    }
  }, [selectedCategories, allSubCategoryOptions]);
  
  useEffect(() => {
    fetchAllLocation(currentPage);
    fetchTicketTypeOptions();
    fetchQuickFilter();
    fetchCompaniesDataInsights();
    fetchAllCity();
  }, []);


  useEffect(() => {
    const deptValues = selectedDepartments.map((dept) => dept.value);
    
    fetchCategoriesAndSubCategoriesData(deptValues);
  }, [selectedDepartments]);

  useEffect(() => {
    const deptValues = selectedDepartments.map((dept) => dept.value);
    
    fetchTicketStatusOptions(deptValues);
  }, [selectedDepartments]);

  useEffect(() => {
  if (allDepartmentOptions) {
    fetchDepartmentOptions(allDepartmentOptions);
  }
}, [allDepartmentOptions]);

  const ValueRendererCategory = (selectedCat, optionsCat) => {
    if (selectedCat.length === optionsCat.length) {
      return "All categories";
    } else if (selectedCat.length === 1) {
      return selectedCat[0].label;
    } else {
      return selectedCat.length > 0
        ? `${selectedCat.length} categories selected`
        : "Select Category";
    }
  };

  const ValueRendererSubCategory = (selectedSub, optionsSub) => {
    if (optionsSub.length === 0) {
      return "Select Sub-category";
    }
    if (selectedSub.length === optionsSub.length) {
      return "All sub-categories";
    } else if (selectedSub.length === 1) {
      return selectedSub[0].label;
    } else {
      return selectedSub.length > 0
        ? `${selectedSub.length} sub-categories selected`
        : "Select Sub-category";
    }
  };

  const handleDateRangeChange = (start, end) => {
    setSelectedDateRange({ startDate: start, endDate: end });
  };

  useEffect(() => {
    if (!statusCount || statusCount.length === 0) {
      setStatusData([0, 0]);
    } else {
      setStatusData([
        statusCount.toDo || 0,
        statusCount.inProgress || 0,
        statusCount.underReview || 0,
      ]);
    }
  }, [statusCount]);

  const optionsStatus = {
    chart: {
      type: "donut",
    },
    labels: ["To Do", "In Progress", "Under Review"],

    dataLabels: {
      enabled: false,
    },
    legend: {
      position: "bottom",
    },
    colors: ["#EF2D56", "#357AF6", "#ED7D3A"],
    series: statusData,
    tooltip: {
      y: {
        formatter: function (val, opts) {
          if (val === 1 || val === 0) {
            return val + " Ticket";
          } else {
            return val + " Tickets";
          }
        },
      },
    },
  };

  useEffect(() => {
    if (!slaData || slaData.length === 0) {
      setSeriesData([0, 0]);
    } else {
      setSeriesData([
        slaData.nonViolatedInPercent || 0,
        slaData.violatedInPercent || 0,
      ]);
    }
  }, [slaData]);

  const options = {
    chart: {
      type: "donut",
    },
    labels: ["Non Violated", "SLA Violated"],
    plotOptions: {
      pie: {
        donut: {
          labels: {
            show: true,
            total: {
              showAlways: true,
              show: true,
              label: "#Violated",
              formatter: function () {
                return slaData?.violatedTickets;
              },
            },
          },
        },
      },
    },

    dataLabels: {
      enabled: false,
    },
    legend: {
      position: "bottom",
    },
    colors: ["#1559C0", "#AC3232"],
    series: seriesData,
    tooltip: {
      y: {
        formatter: function (val, opts) {
          return val + "%";
        },
      },
    },
  };

  let barChart = [];
  let barChartOptions = {};

  if (departmentListData && departmentListData.length > 0) {
    barChart = [
      {
        data: departmentListData.map((item) => item.doc_count),
      },
    ];

    barChartOptions = {
      chart: {
        type: "bar",
        toolbar: {
          show: true,
          tools: {
            download: false, // Disable the download option
          },
        },
      },
      xaxis: {
        categories: departmentListData.map((item) =>
          item.key === "tc"
            ? "Tech"
            : item.key === "am"
            ? "Account Management"
            : item.key === "md"
            ? "MSD"
            : item.key === "op"
            ? "Operations"
            : item.key === "it"
            ? "IT"
            : item.key === "is"
            ? "InfoSec"
            : ""
        ),
      },
      colors: ["rgba(36, 121, 249, 1)"],
      tooltip: {
        enabled: true,
        y: {
          formatter: function (value) {
            return value; // Return only the value, customize as needed
          },
          title: {
            formatter: function () {
              return ""; // Remove the title
            },
          },
        },
      },
      dataLabels: {
        enabled: false, // Disable the data labels
      },
    };
  } else {
    // You can add a default or error message here if needed
    console.log("No data available for the bar chart.");
  }

  let barChartTickets = [];
  let barChartTicketsOptions = {};

  if (categoryListData && categoryListData.length > 0) {
    barChartTickets = [
      {
        data: categoryListData.map((item) => item.doc_count),
      },
    ];

    barChartTicketsOptions = {
      chart: {
        type: "bar",
        toolbar: {
          show: true,
          tools: {
            download: false, // Disable the download option
          },
        },
      },
      xaxis: {
        categories: categoryListData.map((item) => item.key),
      },
      plotOptions: {
        bar: {
          borderRadius: 0,
          borderRadiusApplication: "end",
          horizontal: true,
        },
        dataLabels: {
          borderRadius: 0,
          borderRadiusApplication: "end",
          horizontal: true,
        },
      },
      colors: ["rgba(237, 125, 58, 1)"],
      tooltip: {
        enabled: true,
        y: {
          formatter: function (value) {
            return value; // Return only the value, customize as needed
          },
          title: {
            formatter: function () {
              return ""; // Remove the title
            },
          },
        },
      },
      dataLabels: {
        enabled: false, // Disable the data labels
      },
    };
  } else {
    // You can add a default or empty chart configuration here if needed
    barChartTicketsOptions = {
      chart: {
        type: "bar",
        toolbar: {
          show: true,
          tools: {
            download: false, // Disable the download option
          },
        },
      },
      xaxis: {
        categories: [],
      },
      plotOptions: {
        bar: {
          borderRadius: 0,
          borderRadiusApplication: "end",
          horizontal: true,
        },
        dataLabels: {
          borderRadius: 0,
          borderRadiusApplication: "end",
          horizontal: true,
        },
      },
      colors: ["rgba(237, 125, 58, 1)"],
      tooltip: {
        enabled: true,
        y: {
          formatter: function (value) {
            return value; // Return only the value, customize as needed
          },
          title: {
            formatter: function () {
              return ""; // Remove the title
            },
          },
        },
      },
      dataLabels: {
        enabled: false, // Disable the data labels
      },
    };
  }

  let barChartSubCategory = [];
  let barChartSubCategoryOptions = {};

  if (subcategoryListData && subcategoryListData.length > 0) {
    barChartSubCategory = [
      {
        data: subcategoryListData.map((item) => item.doc_count),
      },
    ];

    barChartSubCategoryOptions = {
      chart: {
        type: "bar",
        toolbar: {
          show: true,
          tools: {
            download: false, // Disable the download option
          },
        },
      },
      xaxis: {
        categories: subcategoryListData.map((item) => item.key),
      },
      plotOptions: {
        bar: {
          borderRadius: 0,
          borderRadiusApplication: "end",
          horizontal: true,
        },
        dataLabels: {
          borderRadius: 0,
          borderRadiusApplication: "end",
          horizontal: true,
        },
      },
      colors: ["rgba(237, 125, 58, 1)"],
      tooltip: {
        enabled: true,
        y: {
          formatter: function (value) {
            return value; // Return only the value, customize as needed
          },
          title: {
            formatter: function () {
              return ""; // Remove the title
            },
          },
        },
      },
      dataLabels: {
        enabled: false, // Disable the data labels
      },
    };
  } else {
    // You can add a default or empty chart configuration here if needed
    barChartSubCategoryOptions = {
      chart: {
        type: "bar",
        toolbar: {
          show: true,
          tools: {
            download: false, // Disable the download option
          },
        },
      },
      xaxis: {
        categories: [],
      },
      plotOptions: {
        bar: {
          borderRadius: 0,
          borderRadiusApplication: "end",
          horizontal: true,
        },
        dataLabels: {
          borderRadius: 0,
          borderRadiusApplication: "end",
          horizontal: true,
        },
      },
      colors: ["rgba(237, 125, 58, 1)"],
      tooltip: {
        enabled: true,
        y: {
          formatter: function (value) {
            return value; // Return only the value, customize as needed
          },
          title: {
            formatter: function () {
              return ""; // Remove the title
            },
          },
        },
      },
      dataLabels: {
        enabled: false, // Disable the data labels
      },
    };
  }

  let companySeries = [];
  let companySeriesOption = {};

  if (companyListData && companyListData.length > 0) {
    companySeries = [
      {
        data: companyListData.map((item) => item.doc_count),
      },
    ];

    companySeriesOption = {
      chart: {
        type: "bar",
        toolbar: {
          show: true,
          tools: {
            download: false, // Disable the download option
          },
        },
      },
      xaxis: {
        categories: companyListData.map((item) => item.key),
      },
      plotOptions: {
        bar: {
          borderRadius: 0,
          borderRadiusApplication: "end",
          horizontal: true,
        },
        dataLabels: {
          borderRadius: 0,
          borderRadiusApplication: "end",
          horizontal: true,
        },
      },
      colors: ["rgba(36, 121, 249, 1)"],
      tooltip: {
        enabled: true,
        y: {
          formatter: function (value) {
            return value; // Return only the value, customize as needed
          },
          title: {
            formatter: function () {
              return ""; // Remove the title
            },
          },
        },
      },
      dataLabels: {
        enabled: false, // Disable the data labels
      },
    };
  } else {
    // You can add a default or empty chart configuration here if needed
    companySeriesOption = {
      chart: {
        type: "bar",
        toolbar: {
          show: true,
          tools: {
            download: false, // Disable the download option
          },
        },
      },
      xaxis: {
        categories: [],
      },
      plotOptions: {
        bar: {
          borderRadius: 0,
          borderRadiusApplication: "end",
          horizontal: true,
        },
        dataLabels: {
          borderRadius: 0,
          borderRadiusApplication: "end",
          horizontal: true,
        },
      },
      colors: ["rgba(36, 121, 249, 1)"],
      tooltip: {
        enabled: true,
        y: {
          formatter: function (value) {
            return value; // Return only the value, customize as needed
          },
          title: {
            formatter: function () {
              return ""; // Remove the title
            },
          },
        },
      },
      dataLabels: {
        enabled: false, // Disable the data labels
      },
    };
  }

  let barChartLocation = [];
  let barChartLocationsOptions = {};

  if (locationListData && locationListData.length > 0) {
    barChartLocation = [
      {
        data: locationListData.map((item) => item.doc_count),
      },
    ];

    barChartLocationsOptions = {
      chart: {
        type: "bar",
        toolbar: {
          show: true,
          tools: {
            download: false, // Disable the download option
          },
        },
      },
      xaxis: {
        categories: locationListData.map((item) => item.key),
      },
      plotOptions: {
        bar: {
          borderRadius: 0,
          borderRadiusApplication: "end",
          horizontal: true,
        },
        dataLabels: {
          borderRadius: 0,
          borderRadiusApplication: "end",
          horizontal: true,
        },
      },
      colors: ["rgba(36, 121, 249, 1)"],
      tooltip: {
        enabled: true,
        y: {
          formatter: function (value) {
            return value; // Return only the value, customize as needed
          },
          title: {
            formatter: function () {
              return ""; // Remove the title
            },
          },
        },
      },
      dataLabels: {
        enabled: false, // Disable the data labels
      },
    };
  } else {
    // You can add a default or empty chart configuration here if needed
    barChartLocationsOptions = {
      chart: {
        type: "bar",
        toolbar: {
          show: true,
          tools: {
            download: false, // Disable the download option
          },
        },
      },
      xaxis: {
        categories: [],
      },
      plotOptions: {
        bar: {
          borderRadius: 0,
          borderRadiusApplication: "end",
          horizontal: true,
        },
        dataLabels: {
          borderRadius: 0,
          borderRadiusApplication: "end",
          horizontal: true,
        },
      },
      colors: ["rgba(237, 125, 58, 1)"],
      tooltip: {
        enabled: true,
        y: {
          formatter: function (value) {
            return value; // Return only the value, customize as needed
          },
          title: {
            formatter: function () {
              return ""; // Remove the title
            },
          },
        },
      },
      dataLabels: {
        enabled: false, // Disable the data labels
      },
    };
  }

  const removeDuplicates = (tickets) => {
    const seen = new Set();
    const uniqueTickets = tickets.filter((ticket) => {
      if (seen.has(ticket._id)) {
        return false;
      } else {
        seen.add(ticket._id);
        return true;
      }
    });
    return uniqueTickets.sort(
      (a, b) => new Date(b.sortByDate) - new Date(a.sortByDate)
    );
  };
  const [ticketBackup, setticketBackup] = useState([]);
  const [ticketCall, setTicketCall] = useState(true);
  const [kpiBackup, setKpiBackup] = useState({});
  const [kpiCall, setKpiCall] = useState(true);
  const [slaBackup, setSlaBackup] = useState({});
  const [slaCall, setSlaCall] = useState(true);
  const [statusBackup, setStatusBackup] = useState({});
  const [statusCall, setStatusCall] = useState(true);
  const [ratingBackup, setRatingBackup] = useState({});
  const [ratingCall, setRatingCall] = useState(true);
  const [categoryBackup, setCategoryBackup] = useState([]);
  const [categoryCall, setCategoryCall] = useState(true);
  const [companyBackup, setCompanyBackup] = useState([]);
  const [companyCall, setCompanyCall] = useState(true);
  const [departmentBackup, setDepartmentBackup] = useState([]);
  const [departmentCall, setDepartmentCall] = useState(true);
  const [locationBackup, setLocationBackup] = useState([]);
  const [locationCall, setLocationCall] = useState(true);
  const [subcategoryBackup, setSubcategoryBackup] = useState([]);
  const [subcategoryCall, setSubcategoryCall] = useState(true);

  // Update useEffect for initial data fetch to include relevance
  useEffect(() => {
    if (applyFilterValue) {
      fetchDashboardData(currentPage, "all");
    } else {
      // Set initial applyFilterValue with default relevance
      setApplyFilterValue({
        selectedLocation: [],
        selectedCompanies: [],
        selectedDepartments: [],
        selectedCategories: [],
        selectedSubCategories: [],
        selectedTicketTypes: [],
        selectedCity: [],
        selectedDateRange: { startDate: null, endDate: null },
        selectedRatings: [],
        selectedTicketStatus: [],
        selectedRegions: [],
        selectedEscalations: [],
        selectedRelevance: [{ label: "Relevant", value: "relevant" }],
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [applyFilterValue]);
  const fetchDashboardData = async (page, status) => {
    setLoading(true);
    setShowLoader(true); // Show loader when starting to fetch

    try {
      const selectedCompaniesValue =
        applyFilterValue?.selectedCompanies.length === companyOptions.length
          ? []
          : applyFilterValue?.selectedCompanies.map((data) => data.value);
      const selectedCategoriesValue =
        applyFilterValue?.selectedCategories.length === categoryOptions.length
          ? []
          : applyFilterValue?.selectedCategories.map((data) => data.value);
      const selectedSubCategoriesValue =
        applyFilterValue?.selectedSubCategories.length ===
        filteredSubCategoryOptions.length
          ? []
          : applyFilterValue?.selectedSubCategories.map((data) => data.value);
      const selectedDepartmentsValue =
        applyFilterValue?.selectedDepartments.length ===
        departmentOptions.length
          ? []
          : applyFilterValue?.selectedDepartments.map((data) => data.value);
      const selectedTicketTypesValue =
        applyFilterValue?.selectedTicketTypes.length ===
        ticketTypeOptions.length
          ? []
          : applyFilterValue?.selectedTicketTypes.map((data) => data.value);
      const selectedLocationValue =
        applyFilterValue?.selectedLocation.length === locationData.length
          ? []
          : applyFilterValue?.selectedLocation.map((data) => data.value);
      const selectedCityValue =
        applyFilterValue?.selectedCity.length === cityOptions.length
          ? []
          : applyFilterValue?.selectedCity.map((data) => data.label);
      const selectedCRatingsValue =
        applyFilterValue?.selectedRatings.length === ratingsOptions.length
          ? []
          : applyFilterValue?.selectedRatings.map((data) => data.value);
      const selectedTicketStatusValue =
        applyFilterValue?.selectedTicketStatus.length ===
        ticketStatusOptions.length
          ? []
          : applyFilterValue?.selectedTicketStatus.map((data) => data.value);

      const selectedRegionsValue =
        applyFilterValue?.selectedRegions.length === regionOptions.length
          ? []
          : applyFilterValue?.selectedRegions.map((data) => data.value);

      const selectedEscalationStatusValue =
        applyFilterValue?.selectedEscalations.length ===
        escalationStatusOptions.length
          ? []
          : applyFilterValue?.selectedEscalations.map((data) => data.value);

      const selectedRelevanceValue =
        applyFilterValue?.selectedRelevance.length === relevanceOptions.length
          ? []
          : applyFilterValue?.selectedRelevance.map((data) => data.value) ||
            [{ label: "Relevant", value: "relevant" }].map(
              (data) => data.value
            ); // Default to "relevant"

      const response = await fetchDashboard(
        selectedCompaniesValue,
        selectedDepartmentsValue,
        selectedCategoriesValue,
        selectedSubCategoriesValue,
        selectedTicketTypesValue,
        applyFilterValue?.selectedDateRange.startDate
          ? moment(applyFilterValue?.selectedDateRange.startDate).format(
              "YYYY-MM-DD"
            )
          : "",
        applyFilterValue?.selectedDateRange.endDate
          ? moment(applyFilterValue?.selectedDateRange.endDate).format(
              "YYYY-MM-DD"
            )
          : "",
        selectedLocationValue,
        selectedCityValue,
        activeTab === "filter" ? "all" : status,
        selectedCRatingsValue,
        selectedTicketStatusValue,
        selectedRegionsValue,
        selectedEscalationStatusValue,
        selectedRelevanceValue
      );

      if (response?.status === 200) {
        setKpiData(response?.data?.data?.kpi);
        setRatingData(response?.data?.data?.rating);
        setSlaData(response?.data?.data?.sla);
        setStatusCount(response?.data?.data?.statusCount);
        setCategoryListData(response?.data?.data?.categoryList);
        setCompanyListData(response?.data?.data?.companyList);
        setDepartmentListData(response?.data?.data?.departmentList);
        setLocationListData(response?.data?.data?.locationList);
        setSubcategoryListData(response?.data?.data?.subCategoryList);

        if (kpiCall) {
          setKpiBackup(response?.data?.data?.kpi);
          setKpiCall(false);
        }
        if (slaCall) {
          setSlaBackup(response?.data?.data?.sla);
          setSlaCall(false);
        }
        if (statusCall) {
          setStatusBackup(response?.data?.data?.statusCount);
          setStatusCall(false);
        }
        if (ratingCall) {
          setRatingBackup(response?.data?.data?.rating);
          setRatingCall(false);
        }
        if (categoryCall) {
          setCategoryBackup(response?.data?.data?.categoryList);
          setCategoryCall(false);
        }
        if (companyCall) {
          setCompanyBackup(response?.data?.data?.companyList);
          setCompanyCall(false);
        }
        if (departmentCall) {
          setDepartmentBackup(response?.data?.data?.departmentList);
          setDepartmentCall(false);
        }
        if (locationCall) {
          setLocationBackup(response?.data?.data?.locationList);
          setLocationCall(false);
        }
        if (subcategoryCall) {
          setSubcategoryBackup(response?.data?.data?.subCategoryList);
          setSubcategoryCall(false);
        }
      }

      const responseFilter = await fetchDashboardTickets(
        page,
        selectedLocationValue,
        selectedCompaniesValue,
        selectedDepartmentsValue,
        selectedCategoriesValue,
        selectedSubCategoriesValue,
        selectedTicketTypesValue,
        selectedCityValue,
        selectedDateRange.startDate
          ? moment(selectedDateRange.startDate).format("YYYY-MM-DD")
          : "",
        selectedDateRange.endDate
          ? moment(selectedDateRange.endDate).format("YYYY-MM-DD")
          : "",
        status,
        selectedCRatingsValue,
        selectedTicketStatusValue,
        selectedRegionsValue,
        selectedEscalationStatusValue,
        selectedRelevanceValue
      );

      if (responseFilter?.data?.statusValue === 200) {
        const newTickets = responseFilter.data.data;
        if (newTickets.length === 0) {
          setHasMoreTickets(false);
        } else {
          setHasMoreTickets(true);
          setTickets((prevTickets) => {
            const combinedTickets = [...prevTickets, ...newTickets];
            const uniqueTickets = removeDuplicates(combinedTickets);
            return uniqueTickets;
          });
        }

        if (ticketCall) {
          setticketBackup(newTickets);
          setTicketCall(false);
        }
      } else {
        setTickets([]);
      }
    } catch (error) {
    } finally {
      setTimeout(() => {
        setLoading(false);
        setShowLoader(false);
      }, 700);
    }
  };

  useEffect(() => {
    if (hasMoreTickets) {
      fetchDashboardData(currentPage + 1, activeTab);
    }
  }, [hasMoreTickets]);

  const fetchAllData = async (id) => {
    try {
      const response = await fetchDataBasedOnTktId(id);
      if (response.statusValue === 200) {
        setAllData(response.data.actionTimeline);
        setEscData(response.data.escalationTimeline);
        return response.data;
      } else {
        setAllData([]);
        return {};
      }
    } catch (error) {
      console.error("Error fetching ticket data:", error);
      return {};
    }
  };

  const uniqueLists = async (ticketId = "") => {
    const resTicketData = await fetchAllData(
      ticketId ? ticketId : modalTicketId
    );
    setTicketDetails(resTicketData);
    setTickets((prevTickets) => {
      const uniqueTickets = removeDuplicates(prevTickets);
      return uniqueTickets.map((ticket) =>
        ticket._id === (ticketId ? ticketId : modalTicketId)
          ? resTicketData
          : ticket
      );
    });
  };

  useEffect(() => {
    fetchDashboardData(currentPage, activeTab);
  }, [currentPage, activeTab]);

  const handleClearAll = () => {
    setTickets(ticketBackup);
    setKpiData(kpiBackup);
    setSlaData(slaBackup);
    setStatusData(statusBackup);
    setRatingData(ratingBackup);
    setCategoryListData(categoryBackup);
    setCompanyListData(companyBackup);
    setDepartmentListData(departmentBackup);
    setLocationListData(locationBackup);
    setSubcategoryListData(subcategoryBackup);
    setSelectedLocation([]);
    setSelectedCompanies([]);
    setSelectedCategories([]);
    setSelectedSubCategories([]);
    setSelectedDepartments([]);
    setSelectedTicketTypes([]);
    setSelectedTicketStatus([]);
    setSelectedRatings([]);
    setSelectedCity([]);
    setSelectedDateRange({});
    setActiveTab("all");
    setApplyFilterValue(null);
    setSelectedRegions([]);
    setSelectedEscalations([]);
    setSelectedRelevance([]);
    setActiveQuickFilter(null); // Reset quick filter

    // Reset city options by fetching without region filter
    fetchAllCity([]);
  };

  const handleUpdateStatus = async (status, values) => {
    try {
      const response = await submitTicketStatus(modalTicketId, status, values);

      if (response.statusValue === 200) {
        setShowChangeStatusModal(false);
        showToastSuccess("Status updated successfully");
        uniqueLists();
      } else if (response.statusValue === 400) {
        showToast(response.message);
      }
    } catch (error) {
      console.log(error, "error");
      showToast(
        `Error fetching update status : ${error?.response?.data?.error?.message}`
      );
    }
  };

  const handleButtonClick = async (ticketId, buttonValue) => {
    try {
      const statusObj = ticketDetails?.statusOption?.find(
        (e) => e.status === buttonValue
      );
      const hasFields = statusObj?.fields && statusObj.fields.length > 0;
      setModalTicketId(ticketId);
      setModalButtonValue(buttonValue);

      if (hasFields) {
        setShowChangeStatusModal(true);
      } else {
        const resData = await updateTicketStatus(ticketId, buttonValue);
        if (resData?.statusText === "Failed") {
          showToast(`${resData?.message}`);
        } else if (resData?.statusValue === 400) {
          showToast(resData?.message);
        } else {
          uniqueLists(ticketId);
          showToastSuccess("Status updated successfully");
        }
      }
    } catch (error) {
      console.error("API Error:", error);
    }
  };

  const openNewTabWithRoute = (tktNumber, tktStatus) => {
    localStorage.setItem("tktStatus", tktStatus);
    const url = new URL(`/ticket-lists`, window.location.origin);
    url.searchParams.set("ticketNumber", tktNumber);
    // url.searchParams.set("ticketStatus", tktStatus);
    window.open(url, "_blank");
  };

  const handleSelectButtonClick = async (ticketId) => {
    let ticketData = {};
    tickets.forEach((e) => {
      if (e._id === ticketId) ticketData = e;
    });
    setTicketDetails(ticketData);
    setSelectedTicketId(ticketId);
    //openNewTabWithRoute(ticketData);
  };

  const handelTicketTab = (tab) => {
    setActiveTabTicket(tab);
  };

  // Rating UI
  const getRatingImage = (avgRating) => {
    if (avgRating >= 1 && avgRating <= 1.4) return HappinessRating1;
    if (avgRating >= 1.5 && avgRating <= 1.9) return HappinessRating15;
    if (avgRating >= 2 && avgRating <= 2.4) return HappinessRating2;
    if (avgRating >= 2.5 && avgRating <= 2.9) return HappinessRating25;
    if (avgRating >= 3 && avgRating <= 3.4) return HappinessRating3;
    if (avgRating >= 3.5 && avgRating <= 3.9) return HappinessRating35;
    if (avgRating >= 4 && avgRating <= 4.4) return HappinessRating4;
    if (avgRating >= 4.5 && avgRating <= 4.9) return HappinessRating45;
    if (avgRating === 5) return HappinessRating5;
    return HappinessRating5;
  };
  const ratingImage = getRatingImage(ratingData?.avgRating);

  // Equal Height of TicketLis and Charts
  const ticketListRef = useRef(null);
  const happinessBoxesRef = useRef(null);
  useEffect(() => {
    const adjustHeightDash = () => {
      if (ticketListRef.current && happinessBoxesRef.current) {
        const adjustedHeight = happinessBoxesRef.current.offsetHeight - 32;
        ticketListRef.current.style.height = `${adjustedHeight}px`;
      }
    };
    // Adjust height on initial render
    adjustHeightDash();
    // Adjust height on window resize
    window.addEventListener("resize", adjustHeightDash);
    // Clean up event listener
    return () => {
      window.removeEventListener("resize", adjustHeightDash);
    };
  }, []);

  useEffect(() => {
    setCurrentPage(1);
  }, [selectedLocation]);

  // Intersection Observer
  const lastTicketElementRef = useCallback(
    (node) => {
      if (loading) return;
      if (observer.current) observer.current.disconnect();
      observer.current = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting && hasMoreTickets) {
          setCurrentPage((prevPage) => prevPage + 1);
        }
      });
      if (node) observer.current.observe(node);
    },
    [loading, hasMoreTickets]
  );

  useEffect(() => {
    if (loading) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }

    // Cleanup function to ensure overflow style is reset
    return () => {
      document.body.style.overflow = "auto";
    };
  }, [loading]);

  // FullScreen Chart
  // const [showChartModal, setShowChartModal] = useState(false);
  // const handleOpenModal = () => setShowChartModal(true);
  // const handleCloseModal = () => setShowChartModal(false);

  const fetchQuickFilter = async () => {
    try {
      const response = await quickFilter();
      if (response.data.statusValue === 200) {
        const quickFilter = response.data.data.map((e) => ({
          label: e.label,
          filter: e.filter?.ticketType,
        }));

        const typeRR = response.data.raiseTicket
          .sort((a, b) => a.label.localeCompare(b.label))
          .map((type) => ({
            label: type.label,
            value: type.ticketType,
            status: type.forClient,
          }));

        setQuick(quickFilter);

        setDataRaiseTT(typeRR);
      } else {
        setQuick([]);
        setDataRaiseTT([]);
      }
    } catch (error) {
      console.error("Error fetching quick filter", error);
    }
  };

  // Quick filter options with predefined ticket types and statuses
  const quickFilterOptions = [
    {
      label: "Actionable tickets without under review",
      ticketTypes: ["internal", "support", "spoc"],
      statuses: ["To Do", "In Progress"],
      groupType: ["op"],
    },
    {
      label: "Actionable tickets with under review",
      ticketTypes: ["internal", "support", "spoc"],
      statuses: ["To Do", "In Progress", "Under Review"],
      groupType: ["op"],
    },
    {
      label: "R&M",
      ticketTypes: ["R&M"],
      statuses: [],
    },
    {
      label: "OPs Task",
      ticketTypes: ["op-tasks"],
      statuses: [],
    },
    {
      label: "Snags",
      ticketTypes: ["snag", "snag-internal"],
      statuses: [],
    },
  ];

  const handleQuickFilterToggle = (filterLabel) => {
    if (activeQuickFilter === filterLabel) {
      // If the same filter is clicked, clear it
      handleClearAll();
      return;
    }


    // Reset all filter states to empty arrays
    setSelectedTicketTypes([]);
    setSelectedTicketStatus([]);
    setSelectedDepartments([]);
    setSelectedCategories([]);
    setSelectedSubCategories([]);
    setSelectedLocation([]);
    setSelectedCompanies([]);
    setSelectedCity([]);
    setSelectedRegions([]);
    setSelectedEscalations([]);
    setSelectedRelevance([]);
    setSelectedRatings([]);
    setTickets([]);
    setCurrentPage(1);

    
    // Set the new active filter
    setActiveQuickFilter(filterLabel);
    const selectedFilter = quickFilterOptions.find(
      (option) => option.label === filterLabel
    );
    if (!selectedFilter) return;

    // Set ticket types and statuses, update applyFilterValue, and fetch data
    const selectedTypes = ticketTypeOptions.filter((option) =>
      selectedFilter.ticketTypes?.includes(option.value)
    );
    setSelectedTicketTypes(selectedTypes);

    const selectedStatuses = ticketStatusOptions.filter((option) =>
      selectedFilter.statuses?.includes(option.value)
    );
    setSelectedTicketStatus(selectedStatuses);

    const selectedDept = departmentOptions.filter((option) =>
      selectedFilter.groupType?.includes(option.value)
    );
    setSelectedDepartments(selectedDept);

    setApplyFilterValue({
      selectedLocation: [],
      selectedCompanies: [],
      selectedDepartments: selectedDept,
      selectedCategories: [],
      selectedSubCategories: [],
      selectedTicketTypes: selectedTypes,
      selectedCity: [],
      selectedDateRange: { startDate: null, endDate: null },
      selectedRatings: [],
      selectedTicketStatus: selectedStatuses,
      selectedRegions: [],
      selectedEscalations: [],
      selectedRelevance: [],
    });

    setTickets([]);
    setCurrentPage(1);
    setActiveTab("filter");
  };

  const renderTooltip = (label) => {
    if (label === "Actionable tickets without under review") {
      return (
        <Tooltip id={`tooltip-${label}`}>
          Shows all support tickets raised by clients + SPOCs + Smartworks
          employees
        </Tooltip>
      );
    } else if (label === "Actionable tickets with under review") {
      return (
        <Tooltip id={`tooltip-${label}`}>
          Shows all support tickets raised by clients + SPOCs + Smartworks
          employees, including those in 'Under Review' status
        </Tooltip>
      );
    }
    return null; // No tooltip for other buttons
  };

  const fetchUsersData = async () => {
    try {
      const response = await axiosInstance.get(
        `${process.env.REACT_APP_API_FILE_UPLOAD}core/users/me`
      );
      if (response.status === 200) {
        setUserDetails(response?.data?.data);
      }
    } catch (error) {
      console.error("Error fetching categories and subcategories", error);
    }
  };

  useEffect(() => {
    fetchUsersData();
  }, []);

  // Add useEffect to fetch user roles on component mount
  const fetchUserRoles = async () => {
    try {
      const response = await getAssigneeBaseInfo();
      if (response?.statusValue === 200) {
        const groupType = response?.data?.internalUser?.groupType || [];
        setGroupTypeOpExist(groupType?.includes("op"), "groupType");
        setGroupTypeOpExistAm(groupType?.includes("am"), "groupType");
        console.log(groupType,"groupType")
        setAllDepartmentOptions(groupType.join(','));
      }
    } catch (error) {
      console.error("Error fetching user roles:", error);
    }
  };
  useEffect(() => {
    fetchUserRoles();
    
  }, []);

  // Example usage
  const handleRegionChange = (selected) => {
    setSelectedRegions(selected);
    const regionValues = selected.map((region) => region.value);
    fetchAllCity(regionValues);
   setSelectedCity([])
   setSelectedLocation([])
   setSelectedCompanies([])
  };

  const handleCityChange = (selected) => {
    setSelectedCity(selected);
    const cityValues = selected.map((city) => city.value);
    fetchAllLocation(cityValues);
    setSelectedLocation([])
    setSelectedCompanies([])
  };

  const handleDepartmentChange = (selected) => {
    setSelectedDepartments(selected);
    const deptValues = selected.map((dept) => dept.value);
    fetchTicketStatusOptions(deptValues);
    fetchCategoriesAndSubCategoriesData(deptValues);
    setSelectedSubCategories([])
    setSelectedCategories([])
    setSelectedTicketStatus([]);
  };

  const handleTicketStatusChange = (selected) => {
    setSelectedTicketStatus(selected);
    // setSelectedSubCategories([])
    // setSelectedCategories([])
  }

  return (
    <Fragment>
      <Header
        handleSelectButtonClick={handleSelectButtonClick}
        selectedTicketId={selectedTicketId}
        setCurrentPage={setCurrentPage}
        setActiveTab={setActiveTab}
        setRaiseticketStatud={setRaiseticketStatud}
        dataRaiseTT={dataRaiseTT}
        userDetails={userDetails}
      />
      <div className="wrapper d-flex">
        <Sidebar
          activeTab={activeTabTicket}
          handleTabClick={handelTicketTab}
          locationData={[]}
          selectedLocation={""}
        />
      </div>
      <section className="MainContent">
        <main className="DashboardPage">
          <div className="container-fluid">
            <div className="row">
              <div className="col-md-12">
                <div className="PageTitle">
                  <h2>Insights</h2>
                  <a
                    className="AdvancedFilterBtn"
                    aria-controls="example-collapse-text"
                    aria-expanded={filterOpen}
                    onClick={() => setFilterOpen(!filterOpen)}
                  >
                    {filterOpen ? (
                      <div className="d-flex align-items-center">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="8"
                          height="8"
                          viewBox="0 0 6 6"
                          fill="none"
                        >
                          <path
                            d="M6 5.154L5.154 6L3 3.846L0.846 6L0 5.154L2.154 3L0 0.846L0.846 0L3 2.154L5.154 0L6 0.846L3.846 3L6 5.154Z"
                            fill="#fff"
                          />
                        </svg>
                        <span className="ms-1">Close</span>
                      </div>
                    ) : (
                      "+ Advanced Filters"
                    )}
                  </a>
                </div>
                &nbsp;
                {groupTypeOpExist ? (
                  <div className="ToggleByStatus">
                    {quickFilterOptions.map((filterItem) => (
                      <OverlayTrigger
                        key={filterItem.label}
                        placement="top" // Tooltip position (can be 'top', 'bottom', 'left', 'right')
                        overlay={renderTooltip(filterItem.label) || <span />}
                      >
                        <ToggleButton
                          id={`toggle-${filterItem.label}`}
                          className={`Filt_Status_Toggle ${
                            activeQuickFilter === filterItem.label
                              ? "active"
                              : ""
                          }`}
                          type="checkbox"
                          variant="dark"
                          checked={activeQuickFilter === filterItem.label}
                          onChange={() =>
                            handleQuickFilterToggle(filterItem.label)
                          }
                        >
                          {filterItem.label}
                        </ToggleButton>
                      </OverlayTrigger>
                    ))}
                  </div>
                ) : (
                  ""
                )}
                <Collapse in={filterOpen}>
                  <div id="example-collapse-text">
                    <div className="AdvancedFilterContainer">
                      <h5>Filter by -</h5>

                      <div className="row">
                        {/* Filter Column 1 */}
                        <div className="col-md-4">
                          <div className="AdvancedFilter_FormBlock_Title">
                            <span className="AdvFilterTitleIcon">
                              <img src={FilterLocationIcon} alt="" />
                            </span>
                            <h4>Location</h4>
                          </div>

                          <div className="AdvancedFilter_FormBlock AdvancedFilter_FormBlock_ColView">
                            <label className="FormBlock_label">Region</label>
                            <div className="MultiSelect_container1">
                              <MultiSelect
                                options={regionOptions}
                                value={selectedRegions}
                                onChange={handleRegionChange}
                                labelledBy="Select Region"
                                ArrowRenderer={ArrowRenderer}
                                className="DashFilterMultiselect"
                                valueRenderer={ValueRendererRegion}
                              />
                            </div>
                            {/* <div className="FormBlock_Note FormBlock_Validation" >*Select a region first</div> */}
                          </div>

                          <div className="AdvancedFilter_FormBlock AdvancedFilter_FormBlock_ColView">
                            <label className="FormBlock_label">City</label>
                            <div className="MultiSelect_container1">
                              <MultiSelect
                                options={cityOptions}
                                value={selectedCity}
                                onChange={handleCityChange}
                                labelledBy="Select City"
                                ArrowRenderer={ArrowRenderer}
                                className="DashFilterMultiselect"
                                valueRenderer={ValueRendererCity}
                              />
                            </div>
                            {/* <div className="FormBlock_Note FormBlock_Validation" >*Select a region first</div> */}
                          </div>

                          <div className="AdvancedFilter_FormBlock AdvancedFilter_FormBlock_ColView">
                            <label className="FormBlock_label">Location</label>
                            <div className="MultiSelect_container1">
                              <MultiSelect
                                options={locationData}
                                value={selectedLocation}
                                onChange={handleChange}
                                labelledBy="Select Locations"
                                selectAllLabel="Select All"
                                ArrowRenderer={ArrowRenderer}
                                valueRenderer={ValueRenderer}
                                className="DashFilterMultiselect"
                              />
                            </div>
                          </div>

                          <div className="AdvancedFilter_FormBlock AdvancedFilter_FormBlock_ColView">
                            <label className="FormBlock_label">Company</label>
                            <div className="MultiSelect_container1">
                              <MultiSelect
                                options={companyOptions}
                                value={selectedCompanies}
                                onChange={setSelectedCompanies}
                                labelledBy="Select Company"
                                ArrowRenderer={ArrowRenderer}
                                className="DashFilterMultiselect"
                                valueRenderer={ValueRendererCompany}
                              />
                            </div>
                          </div>
                        </div>

                        {/* Filter Column 2 */}
                        <div className="col-md-4">
                          <div className="AdvancedFilter_FormBlock_Title">
                            <span className="AdvFilterTitleIcon">
                              <img
                                src={FilterTicketClassificationIcon}
                                alt=""
                              />
                            </span>
                            <h4>Ticket classification</h4>
                          </div>

                          <div className="AdvancedFilter_FormBlock AdvancedFilter_FormBlock_ColView">
                            <label className="FormBlock_label">
                              Department
                            </label>
                            <div className="MultiSelect_container1">
                              <MultiSelect
                                options={departmentOptions}
                                value={selectedDepartments}
                                onChange={handleDepartmentChange}
                                labelledBy="Select Department"
                                ArrowRenderer={ArrowRenderer}
                                className="DashFilterMultiselect"
                                valueRenderer={ValueRendererDepartment}
                              />
                            </div>
                          </div>

                          <div className="AdvancedFilter_FormBlock AdvancedFilter_FormBlock_ColView">
                            <label className="FormBlock_label">Status</label>
                            <div className="MultiSelect_container1">
                              <MultiSelect
                                options={ticketStatusOptions}
                                value={selectedTicketStatus}
                                onChange={handleTicketStatusChange}
                                labelledBy="Select Ticket Status"
                                ArrowRenderer={ArrowRenderer}
                                className="DashFilterMultiselect"
                                valueRenderer={ValueRendererTicketStatus}
                              />
                            </div>
                          </div>

                          <div className="AdvancedFilter_FormBlock AdvancedFilter_FormBlock_ColView">
                            <label className="FormBlock_label">Category</label>
                            <div className="MultiSelect_container1">
                              <MultiSelect
                                options={categoryOptions}
                                value={selectedCategories}
                                onChange={setSelectedCategories}
                                labelledBy="Select Category"
                                ArrowRenderer={ArrowRenderer}
                                className="DashFilterMultiselect"
                                valueRenderer={ValueRendererCategory}
                              />
                            </div>
                          </div>

                          <div className="AdvancedFilter_FormBlock AdvancedFilter_FormBlock_ColView">
                            <label className="FormBlock_label">
                              Sub-category
                            </label>
                            <div className="MultiSelect_container1">
                              <MultiSelect
                                options={filteredSubCategoryOptions}
                                value={selectedSubCategories}
                                onChange={setSelectedSubCategories}
                                labelledBy="Select Sub-Category"
                                ArrowRenderer={ArrowRenderer}
                                valueRenderer={ValueRendererSubCategory}
                                className="DashFilterMultiselect"
                              />
                            </div>
                          </div>
                        </div>

                        {/* Filter Column 3 */}
                        <div className="col-md-4">
                          <div className="AdvancedFilter_FormBlock_Title">
                            <span className="AdvFilterTitleIcon">
                              <img src={FilterMoreFIltersIcon} alt="" />
                            </span>
                            <h4>More filters</h4>
                          </div>

                          <div className="AdvancedFilter_FormBlock AdvancedFilter_FormBlock_ColView">
                            <label className="FormBlock_label">
                              Date range
                            </label>
                            <div className="MultiSelect_container1">
                              <DateRangePicker
                                initialSettings={{
                                  minDate: "03/01/2024",
                                  maxDate: new Date(),
                                  //dateLimit: { days: 31 },
                                }}
                                onCallback={(start, end) =>
                                  handleDateRangeChange(start, end)
                                }
                              >
                                <input
                                  type="text"
                                  className="form-control DateRangeDashFilter"
                                  placeholder="Select Date Range"
                                  value={
                                    selectedDateRange.startDate &&
                                    selectedDateRange.endDate
                                      ? `${selectedDateRange.startDate.format(
                                          "MM/DD/YYYY"
                                        )} - ${selectedDateRange.endDate.format(
                                          "MM/DD/YYYY"
                                        )}`
                                      : ""
                                  }
                                  readOnly
                                />
                              </DateRangePicker>
                            </div>
                          </div>

                          <div className="AdvancedFilter_FormBlock AdvancedFilter_FormBlock_ColView">
                            <label className="FormBlock_label">
                              Ticket Type
                            </label>

                            <div className="MultiSelect_container1">
                              <MultiSelect
                                options={ticketTypeOptions}
                                value={selectedTicketTypes}
                                onChange={setSelectedTicketTypes}
                                labelledBy="Select Ticket Types"
                                ArrowRenderer={ArrowRenderer}
                                className="DashFilterMultiselect"
                                valueRenderer={ValueRendererTicket}
                              />
                            </div>
                          </div>

                          <div className="AdvancedFilter_FormBlock AdvancedFilter_FormBlock_ColView">
                            <label className="FormBlock_label">
                              Escalation Status
                            </label>

                            <div className="MultiSelect_container1">
                              <MultiSelect
                                options={escalationStatusOptions}
                                value={selectedEscalations}
                                onChange={setSelectedEscalations}
                                labelledBy="Select Escalation Status"
                                ArrowRenderer={ArrowRenderer}
                                className="DashFilterMultiselect"
                                valueRenderer={ValueRendererEscalation}
                              />
                            </div>
                          </div>

                          <div className="AdvancedFilter_FormBlock AdvancedFilter_FormBlock_ColView">
                            <label className="FormBlock_label">Ratings</label>

                            <div className="MultiSelect_container1">
                              <MultiSelect
                                options={ratingsOptions}
                                value={selectedRatings}
                                onChange={setSelectedRatings}
                                labelledBy="Select Ticket Ratings"
                                ArrowRenderer={ArrowRenderer}
                                className="DashFilterMultiselect"
                                valueRenderer={ValueRendererRatings}
                              />
                            </div>
                          </div>
                          

                            {groupTypeOpExistAm && (
                              <div className="AdvancedFilter_FormBlock AdvancedFilter_FormBlock_ColView">
                                <label className="FormBlock_label">
                                  Relevance
                                </label>

                                <div className="MultiSelect_container1">
                                  <MultiSelect
                                    options={relevanceOptions}
                                    value={selectedRelevance}
                                    onChange={setSelectedRelevance}
                                    labelledBy="Select Relevance"
                                    ArrowRenderer={ArrowRenderer}
                                    className="DashFilterMultiselect"
                                    valueRenderer={ValueRendererRelevance}
                                  />
                                </div>
                              </div>
                            )}
                          
                        </div>
                      </div>

                      <div className="row">
                        <div className="col-md-12">
                          <div className="FilterContentFooter">
                            <div className="d-flex justify-content-end">
                              <button
                                type="button"
                                className="btn ClearAllBtn"
                                style={{
                                  cursor: "pointer",
                                }}
                                onClick={handleClearAll}
                              >
                                Clear All
                              </button>
                              <button
                                type="button"
                                className="btn ApplyFilterBtn"
                                disabled={
                                  selectedLocation.length === 0 &&
                                  selectedCompanies.length === 0 &&
                                  selectedCategories.length === 0 &&
                                  selectedSubCategories.length === 0 &&
                                  selectedDepartments.length === 0 &&
                                  selectedTicketTypes.length === 0 &&
                                  selectedCity.length === 0 &&
                                  selectedDateRange.endDate == null &&
                                  selectedDateRange.startDate == null &&
                                  selectedRatings.length === 0 &&
                                  selectedTicketStatus.length === 0 &&
                                  selectedRegions.length === 0 &&
                                  selectedEscalations.length === 0 &&
                                  selectedRelevance.length === 0
                                }
                                onClick={() => {
                                  setApplyFilterValue((prevState) => ({
                                    ...prevState,
                                    selectedLocation: selectedLocation,
                                    selectedCompanies: selectedCompanies,
                                    selectedDepartments: selectedDepartments,
                                    selectedCategories: selectedCategories,
                                    selectedSubCategories:
                                      selectedSubCategories,
                                    selectedTicketTypes: selectedTicketTypes,
                                    selectedCity: selectedCity,
                                    selectedDateRange: selectedDateRange,
                                    selectedRatings: selectedRatings,
                                    selectedTicketStatus: selectedTicketStatus,
                                    selectedRegions: selectedRegions,
                                    selectedEscalations: selectedEscalations,
                                    selectedRelevance: selectedRelevance,
                                  }));
                                  handleTabClickWithFetch("filter");
                                  setTickets([]);
                                  setCurrentPage(1);
                                }}
                              >
                                Apply Filter
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </Collapse>
              </div>
            </div>
            <div className="row">
              <div className="col-md-12">
                <div className="TicketTypeFilter">
                  <div
                    className={`TicketTypeFilter_Ticket ${
                      activeTab === "all" || activeTab === "filter"
                        ? "active"
                        : ""
                    } ${loading ? "disabled" : ""}`}
                    onClick={() => {
                      // Only handle click if not loading and tab is not already active
                      if (
                        !loading &&
                        !(activeTab === "all" || activeTab === "filter")
                      ) {
                        fetchDashboardData(currentPage, "all");
                        handleTabClickWithFetch("all");
                      }
                    }}
                  >
                    <p>All Tickets</p>
                    <h3>{kpiData?.totalTickets}</h3>
                  </div>
                  <div
                    className={`TicketTypeFilter_Ticket ${
                      activeTab === "open" ? "active" : ""
                    } ${loading ? "disabled" : ""}`}
                    onClick={() => {
                      // Only handle click if not loading and tab is not already active
                      if (!loading && !(activeTab === "open")) {
                        fetchDashboardData(currentPage, "open");
                        handleTabClickWithFetch("open");
                      }
                    }}
                  >
                    <p>Open Tickets</p>
                    <h3>{kpiData?.openTickets}</h3>
                  </div>
                  <div
                    className={`TicketTypeFilter_Ticket ${
                      activeTab === "critical" ? "active" : ""
                    } ${loading ? "disabled" : ""}`}
                    onClick={() => {
                      // Only handle click if not loading and tab is not already active
                      if (!loading && !(activeTab === "critical")) {
                        fetchDashboardData(currentPage, "critical");
                        handleTabClickWithFetch("critical");
                      }
                    }}
                  >
                    <p>Critical </p>
                    <h3>{kpiData?.criticalTickets}</h3>
                  </div>
                  <div
                    className={`TicketTypeFilter_Ticket ${
                      activeTab === "returned" ? "active" : ""
                    } ${loading ? "disabled" : ""}`}
                    onClick={() => {
                      // Only handle click if not loading and tab is not already active
                      if (!loading && !(activeTab === "returned")) {
                        fetchDashboardData(currentPage, "returned");
                        handleTabClickWithFetch("returned");
                      }
                    }}
                  >
                    <p>Returned </p>
                    <h3>{kpiData?.returnedTickets}</h3>
                  </div>
                  <div
                    className={`TicketTypeFilter_Ticket ${
                      activeTab === "reopen" ? "active" : ""
                    } ${loading ? "disabled" : ""}`}
                    onClick={() => {
                      // Only handle click if not loading and tab is not already active
                      if (!loading && !(activeTab === "reopen")) {
                        fetchDashboardData(currentPage, "reopen");
                        handleTabClickWithFetch("reopen");
                      }
                    }}
                  >
                    <p>Re-opened </p>
                    <h3>{kpiData?.reopenedTickets}</h3>
                  </div>
                  <div
                    className={`TicketTypeFilter_Ticket ${
                      activeTab === "pastdue" ? "active" : ""
                    } ${loading ? "disabled" : ""}`}
                    onClick={() => {
                      // Only handle click if not loading and tab is not already active
                      if (!loading && !(activeTab === "pastdue")) {
                        fetchDashboardData(currentPage, "pastdue");
                        handleTabClickWithFetch("pastdue");
                      }
                    }}
                  >
                    <p>Violated </p>
                    <h3>{kpiData?.pastDueTickets}</h3>
                  </div>
                  <div
                    className={`TicketTypeFilter_Ticket ${
                      activeTab === "nonviolated" ? "active" : ""
                    } ${loading ? "disabled" : ""}`}
                    onClick={() => {
                      // Only handle click if not loading and tab is not already active
                      if (!loading && !(activeTab === "nonviolated")) {
                        fetchDashboardData(currentPage, "nonviolated");
                        handleTabClickWithFetch("nonviolated");
                      }
                    }}
                  >
                    <p>Non-violated</p>
                    <h3>{kpiData?.nonViolatedTickets}</h3>
                  </div>
                  <div
                    className={`TicketTypeFilter_Ticket ${
                      activeTab === "underreview" ? "active" : ""
                    } ${loading ? "disabled" : ""}`}
                    onClick={() => {
                      // Only handle click if not loading and tab is not already active
                      if (!loading && !(activeTab === "underreview")) {
                        fetchDashboardData(currentPage, "underreview");
                        handleTabClickWithFetch("underreview");
                      }
                    }}
                  >
                    <p>Under Review</p>
                    <h3>{kpiData?.underReview}</h3>
                  </div>
                  <div
                    className={`TicketTypeFilter_Ticket ${
                      activeTab === "closed" ? "active" : ""
                    } ${loading ? "disabled" : ""}`}
                    onClick={() => {
                      // Only handle click if not loading and tab is not already active
                      if (!loading && !(activeTab === "closed")) {
                        fetchDashboardData(currentPage, "closed");
                        handleTabClickWithFetch("closed");
                      }
                    }}
                  >
                    <p>Closed </p>
                    <h3>{kpiData?.closedTickets}</h3>
                  </div>
                </div>
              </div>
            </div>

            <div className="DashboardCardsContainer">
              <div className="row">
                <div className="col-md-6">
                  <div
                    className="DashboardTicketList"
                    //ref={ticketListRef}
                  >
                    <h2>
                      {activeTab === "all"
                        ? "All Tickets"
                        : activeTab === "open"
                        ? "Open Tickets"
                        : activeTab === "closed"
                        ? "Closed Tickets"
                        : activeTab === "reopen"
                        ? "Re-opened Tickets"
                        : activeTab === "returned"
                        ? "Returned Tickets"
                        : activeTab === "pastdue"
                        ? "Violated Tickets"
                        : activeTab === "nonviolated"
                        ? "Non-violated Tickets"
                        : activeTab === "critical"
                        ? "Critical Tickets"
                        : activeTab === "underreview"
                        ? "Under Review Tickets"
                        : ""}
                    </h2>

                    {loading && currentPage === 1 ? (
                      <div className="d-flex align-items-center justify-content-center heightNodData">
                        <img
                          src="https://smartworks-production.s3.ap-southeast-1.amazonaws.com/assets/loader-sw.gif"
                          width={50}
                          alt="company logo"
                        />
                      </div>
                    ) : tickets.length === 0 && !loading ? (
                      <div className="col-12">
                        <div className="d-flex">
                          <div className="NoTicketsContainer">
                            <div className="NoTicketsBox">
                              <img src={NoDataBg} alt="" />
                              <p className="">No data available to show</p>
                            </div>
                          </div>
                        </div>
                      </div>
                    ) : (
                      <>
                        <div className="ticketListContainer">
                          {tickets.map((ticket, index) => {
                            if (tickets.length === index + 1) {
                              return (
                                <div ref={lastTicketElementRef} key={uuidv4()}>
                                  <Ticket
                                    ticket={ticket}
                                    handleButtonClick={handleButtonClick}
                                    handleSelectButtonClick={
                                      handleSelectButtonClick
                                    }
                                    selectedTicketId={selectedTicketId}
                                    openNewTabWithRoute={openNewTabWithRoute}
                                  />
                                </div>
                              );
                            } else {
                              return (
                                <Ticket
                                  key={uuidv4()}
                                  ticket={ticket}
                                  handleButtonClick={handleButtonClick}
                                  handleSelectButtonClick={
                                    handleSelectButtonClick
                                  }
                                  selectedTicketId={selectedTicketId}
                                  openNewTabWithRoute={openNewTabWithRoute}
                                />
                              );
                            }
                          })}
                        </div>
                        {showLoader && (
                          <div className="loader-wrapper d-flex align-items-center justify-content-center">
                            <img
                              className=""
                              src="https://smartworks-production.s3.ap-southeast-1.amazonaws.com/assets/loader-sw.gif"
                              style={{ width: "30px" }}
                              alt="Loading..."
                            />
                          </div>
                        )}
                      </>
                    )}

                    <ChangeStatusModal
                      show={showChangeStatusModal}
                      onHide={() => setShowChangeStatusModal(false)}
                      modalButtonValue={modalButtonValue}
                      onSubmit={handleUpdateStatus}
                      ticket={ticketDetails}
                      allData={allData}
                    />
                  </div>
                </div>

                {/* Start SLA Compliance & Happiness Rating*/}
                <div
                  className="col-md-6 SLA-HappinessBoxes"
                  ref={happinessBoxesRef}
                >
                  <div className="row">
                    <div className="col-md-6">
                      <div className="card DashboardCard">
                        <div className="card-header">SLA Compliance</div>
                        <div className="card-body px-0">
                          <div className="SLA_Chart_Container">
                            <Chart
                              options={options}
                              series={seriesData}
                              type="donut"
                              width={300}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    {["all", "closed", "filter"]?.includes(activeTab) ? (
                      <div className="col-md-6">
                        <div
                          className="card DashboardCard"
                          style={{ height: "100%" }}
                        >
                          <div className="card-header">Happiness Rating</div>
                          <div className="card-body">
                            <div className="HappinesRating">
                              <img src={ratingImage} alt="" />
                              <h2>{ratingData?.avgRating}/5 Average Rating</h2>
                              <p>
                                {ratingData?.ratingInParcent === null
                                  ? 0
                                  : `${ratingData?.totalRating} (${ratingData?.ratingInParcent}%)`}{" "}
                                Tickets Rated
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    ) : (
                      <div className="col-md-6">
                        <div
                          className="card DashboardCard"
                          style={{ height: "100%" }}
                        >
                          <div className="card-header">
                            Total Ticket By Status
                          </div>
                          <div className="card-body px-0">
                            <div className="SLA_Chart_Container">
                              <Chart
                                options={optionsStatus}
                                series={statusData}
                                type="pie"
                                width={300}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>

                  <div
                    className="card DashboardCard"
                    style={{ marginTop: "14px" }}
                  >
                    <div className="card-header">
                      Company-wise Ticket Volume
                      {/* <a type="button" className="badge text-bg-dark ms-3" onClick={handleOpenModal} >Open Chart</a> */}
                    </div>
                    <div className="card-body">
                      <Chart
                        options={companySeriesOption}
                        series={companySeries}
                        type="bar"
                      />
                    </div>
                  </div>
                </div>
              </div>

              {/* End SLA Compliance & Happiness Rating */}

              <div className="row" style={{ marginTop: "14px" }}>
                <div className="col-md-6">
                  <div className="card DashboardCard">
                    <div className="card-header">
                      Total Tickets By Departments
                    </div>
                    <div className="card-body">
                      <Chart
                        options={barChartOptions}
                        series={barChart}
                        type="bar"
                      />
                    </div>
                  </div>
                </div>

                <div className="col-md-6">
                  <div className="card DashboardCard">
                    <div className="card-header">
                      Total Tickets By Top 5 Locations
                    </div>
                    <div className="card-body">
                      <Chart
                        options={barChartLocationsOptions}
                        series={barChartLocation}
                        type="bar"
                        // height="250"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-md-6">
                  <div className="card DashboardCard">
                    <div className="card-header">
                      Total Tickets By Top 5 Categories
                    </div>
                    <div className="card-body">
                      {/* <img
                        src="https://i.postimg.cc/6qX3RBBr/Total-Tickets-By-Top-5-Sub-Categories.png"
                        height={"227px"}
                        alt
                      /> */}
                      <Chart
                        options={barChartTicketsOptions}
                        series={barChartTickets}
                        type="bar"
                        height="250"
                      />
                    </div>
                  </div>
                </div>

                <div className="col-md-6">
                  <div className="card DashboardCard">
                    <div className="card-header">
                      Total Tickets By Top 5 Sub-Categories
                    </div>
                    <div className="card-body">
                      <Chart
                        options={barChartSubCategoryOptions}
                        series={barChartSubCategory}
                        type="bar"
                        height="250"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </main>
      </section>

      {/* Full-screen modal for the chart */}
      {/* <Modal show={showChartModal} onHide={handleCloseModal} size="lg" dialogClassName="modal-fullscreen">
        <Modal.Header closeButton>
          <Modal.Title>Full-Screen Chart</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Chart
            options={companySeriesOption}
            series={companySeries}
            type="bar"
            height="100%" 
            width="100%"  
          />
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseModal}>
            Close
          </Button>
        </Modal.Footer>
      </Modal> */}
    </Fragment>
  );
};

export default Dashboard;
